import type { PersonRequest } from "@plinknz/tah-website-elements";

import { getBankSVGLines } from "./bank";
import { getSchoolSVGLines } from "./institution";
import { getPersonalChanges } from "./member";
import { getSignatureSVGLines } from "./signature";
import type { BankData } from "../../service/forms/config-generics/bank-details";
import type { PersonalData } from "../../service/forms/config-generics/personal-details";
import type { SchoolData } from "../../service/forms/config-generics/school";
import type { SignatureData } from "../../service/forms/config-generics/signature";
import type { SVGLine } from "./svg";
import { getGenericSVGLines } from "./generic";

export interface SVGSourceData
    extends BankData,
        PersonalData,
        SchoolData,
        SignatureData {
    member: PersonRequest;
}

export interface SVGAttachment {
    name: string;
}

export interface SVGProcessData {
    svgLines: SVGLine[];
    remainingData: SVGSourceData;
}

export function createSVGConfig(data: SVGSourceData) {
    const {
        svgLines: personalLines,
        remainingData: personalRemainingData,
    } = getPersonalChanges(data);
    const {
        svgLines: bankLines,
        remainingData: bankRemainingData,
    } = getBankSVGLines(personalRemainingData);
    const {
        svgLines: schoolLines,
        remainingData: schoolRemainingData,
    } = getSchoolSVGLines(bankRemainingData);
    const {
        svgLines: signatureLines,
        remainingData: signatureRemainingData,
    } = getSignatureSVGLines(schoolRemainingData);
    const otherLines = getGenericSVGLines(signatureRemainingData);

    return [
        ...personalLines,
        ...bankLines,
        ...schoolLines,
        ...signatureLines,
        ...otherLines,
    ];
}
